export default __webpack_public_path__ + "static/ring7-a2a5f02398f558f7f30f9f5de770df87.png";